import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCbbgvWwpZcsYezxFwIX_tTbNx4yn9LQJc",
  authDomain: "moonskins-d88f2.firebaseapp.com",
  projectId: "moonskins-d88f2",
  storageBucket: "moonskins-d88f2.firebasestorage.app",
  messagingSenderId: "499528708909",
  appId: "1:499528708909:web:716b656e54ddc2197019a4",
  measurementId: "G-39Z12WSNHD"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Messaging
export const messaging = getMessaging(firebaseApp);